"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store");
var DEFAULT_STORE_NAME = '__default';
var FROZEN_STORE_NAME = '__frozen';
/** Ensures a value is an array */
var makeArray = function (val) {
    /* istanbul ignore next */
    return Array.isArray(val) ? val : !!val ? [val] : [];
};
/** Takes a single or array of store items and makes a name -> value map */
var makeStoreMap = function (_store) {
    var _a;
    var storeArr = makeArray(_store);
    return storeArr.reduce(function (acc, store) {
        acc[store.name] = store;
        return acc;
    }, (_a = {}, _a[DEFAULT_STORE_NAME] = storeArr[0], _a[FROZEN_STORE_NAME] = store_1.inMemoryStore(), _a));
};
/** Get the default value for a flag from its definition */
var getFlagDefaultValue = function (_a) {
    var flagDef = _a.flagDef;
    return flagDef.default === undefined ? null : flagDef.default;
};
/** Get the value set for the flag for its store */
var getFlagValue = function (_a) {
    var flagDef = _a.flagDef, flagName = _a.flagName, storeMap = _a.storeMap;
    var store = resolveFlagStore({ flagDef: flagDef, storeMap: storeMap });
    return store.get(flagName);
};
/** Get the fully resolved flag value taking into account the default fallback */
var getResolvedFlagValue = function (_a) {
    var frozen = _a.frozen, definitions = _a.definitions, flagName = _a.flagName, storeMap = _a.storeMap;
    if (flagName in frozen) {
        return storeMap[FROZEN_STORE_NAME].get(flagName);
    }
    var flagDef = getFlagDef({ definitions: definitions, flagName: flagName });
    var defaultValue = getFlagDefaultValue({
        flagDef: flagDef
    });
    var value = getFlagValue({
        flagDef: flagDef,
        flagName: flagName,
        storeMap: storeMap
    });
    if (value === undefined || value === null) {
        return defaultValue;
    }
    return value;
};
/** Set the fully resolved flag value taking into account the default fallback */
var setFlagValue = function (_a) {
    var frozen = _a.frozen, definitions = _a.definitions, flagName = _a.flagName, value = _a.value, storeMap = _a.storeMap;
    if (flagName in frozen) {
        console.warn("Feature Flag " + flagName + " is frozen");
        return;
    }
    var flagDef = getFlagDef({ definitions: definitions, flagName: flagName });
    var store = resolveFlagStore({ flagDef: flagDef, storeMap: storeMap });
    var defaultValue = getFlagDefaultValue({
        flagDef: flagDef
    });
    if (JSON.stringify(value) === JSON.stringify(defaultValue)) {
        /* istanbul ignore else  */
        if ('remove' in store) {
            store.remove(flagName);
        }
        else {
            console.warn("Flagg: Attempting to write to readOnly store " + store.name);
        }
    }
    else {
        if ('set' in store) {
            store.set(flagName, value);
        }
        else {
            console.warn("Flagg: Attempting to write to readOnly store " + store.name);
        }
    }
};
/** Get the definition for a flag */
var getFlagDef = function (_a) {
    var definitions = _a.definitions, flagName = _a.flagName;
    return (flagName in definitions ? definitions[flagName] : {});
};
/** Get the store instance for a flag definition */
var resolveFlagStore = function (_a) {
    var flagDef = _a.flagDef, storeMap = _a.storeMap;
    var storeName = flagDef.store;
    if (storeMap[storeName])
        return storeMap[storeName];
    if (storeName !== undefined) {
        console.warn("Flagg store \"" + storeName + "\" not available. Did you forget to include it? Using default store instead.");
    }
    return storeMap[DEFAULT_STORE_NAME];
};
var getFlagType = function (_a) {
    var flagDef = _a.flagDef;
    if (flagDef.options) {
        return 'select';
    }
    if (typeof flagDef.default === 'string') {
        return 'string';
    }
    return 'boolean';
};
/** Create a new feature flags store with Flagg. */
exports.flagg = function (_a) {
    var store = _a.store, _b = _a.definitions, definitions = _b === void 0 ? {} : _b;
    var state = {
        definitions: definitions,
        frozen: {},
        storeMap: makeStoreMap(store)
    };
    var hydrateFrom = function (storeToHydrateFrom) {
        var hydrateFromStores = makeArray(storeToHydrateFrom);
        return Promise.all(hydrateFromStores.map(function (hydrateStore) { return __awaiter(void 0, void 0, void 0, function () {
            var values;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hydrateStore.all()];
                    case 1:
                        values = _a.sent();
                        set(values);
                        return [2 /*return*/];
                }
            });
        }); }));
    };
    var get = function (flagName) {
        return getResolvedFlagValue({
            frozen: state.frozen,
            definitions: state.definitions,
            flagName: String(flagName),
            storeMap: state.storeMap
        });
    };
    var getDefault = function (flagName) {
        return getFlagDefaultValue({
            flagDef: getFlagDef({
                definitions: state.definitions,
                flagName: String(flagName)
            })
        });
    };
    var set = function (flagNameOrFlags, value) {
        if (typeof flagNameOrFlags === 'string') {
            setFlagValue({
                frozen: state.frozen,
                value: value,
                definitions: state.definitions,
                flagName: String(flagNameOrFlags),
                storeMap: state.storeMap
            });
        }
        else {
            Object.entries(flagNameOrFlags).forEach(function (_a) {
                var flagName = _a[0], value = _a[1];
                setFlagValue({
                    frozen: state.frozen,
                    value: value,
                    definitions: state.definitions,
                    flagName: String(flagName),
                    storeMap: state.storeMap
                });
            });
        }
    };
    var isOverridden = function (flagName) {
        var flagDef = getFlagDef({
            flagName: String(flagName),
            definitions: state.definitions
        });
        var type = getFlagType({ flagDef: flagDef });
        return type === 'boolean'
            ? !!get(flagName) !== !!getDefault(flagName)
            : get(flagName) !== getDefault(flagName);
    };
    var setDefinitions = function (definitions) {
        state.definitions = definitions;
    };
    var getDefinitions = function () { return state.definitions; };
    var getAllResolved = function () {
        return Object.keys(state.definitions).reduce(function (acc, flagName) {
            acc[flagName] = get(flagName);
            return acc;
        }, {});
    };
    var getAllOverridden = function () {
        return Object.keys(state.definitions).reduce(function (acc, flagName) {
            if (isOverridden(flagName)) {
                acc[flagName] = get(flagName);
            }
            return acc;
        }, {});
    };
    var freeze = function (flagName) {
        state.storeMap[FROZEN_STORE_NAME].set(String(flagName), get(flagName));
        state.frozen[flagName] = true;
    };
    var freezeAll = function () {
        Object.keys(state.definitions).forEach(function (flagName) {
            return freeze(flagName);
        });
    };
    var isFrozen = function (flagName) { return !!state.frozen[flagName]; };
    var reset = function (flagName) { return set(flagName, getDefault(flagName)); };
    var resetAll = function () {
        return Object.keys(state.definitions).forEach(function (flagName) {
            return reset(flagName);
        });
    };
    return {
        /** Gets a value for a feature flag. */
        get: get,
        /** Sets one or many feature flags. */
        set: set,
        /** Get the default value for a feature flag. */
        getDefault: getDefault,
        /** Checks to see if a feature flag is overridden. */
        isOverridden: isOverridden,
        /** Set the definitions after init. */
        setDefinitions: setDefinitions,
        /** Gets the current set  of definitions. */
        getDefinitions: getDefinitions,
        /** Gets all feature flags with their resolved value. */
        getAllResolved: getAllResolved,
        /** Get only the feature flags that are different than their defaults. */
        getAllOverridden: getAllOverridden,
        /** Freeze a feature flag to prevent further changes. */
        freeze: freeze,
        /** Freeze all feature flags. */
        freezeAll: freezeAll,
        /** Resets a feature flag to its default value. */
        reset: reset,
        /** Reset all feature flags to their default value. */
        resetAll: resetAll,
        /** Check if a feature flag is frozen. */
        isFrozen: isFrozen,
        /** Allows you to hydrate from one or more stores. See the docs on Stores. */
        hydrateFrom: hydrateFrom
    };
};
exports.default = exports.flagg;
//# sourceMappingURL=index.js.map